import {connect} from "react-redux"
import {createSelector} from "reselect"
import {IncomingHttpHeaders} from "http"
import {State} from "../../ducks"
import {filterByExcludeFrom} from "../../utils/excludeFrom"
import {REALM_HEADER} from "../../config/constants"

// Selector for primaryItems
const selectPrimaryItems = (state: State) => state.primarynav.items

const selectShowAsWideView = (_, showAsWideView: boolean) => showAsWideView

const makeSelectItems = createSelector([selectPrimaryItems, selectShowAsWideView], (primaryItems, showAsWideView) =>
    primaryItems.filter(filterByExcludeFrom(showAsWideView)),
)

export const mapStateToProps = (state: State, {showAsWideView}: {showAsWideView: boolean}) => {
    const {
        primarynav: {activeDepartmentIndex, isInPrimaryNav},
        textAlignment,
        text: {
            chevron: {chevronIconAltText},
        },
        settings: {variant, iconsVersionPath},
        request: {siteUrl, headers},
    } = state
    const realm = (headers as IncomingHttpHeaders)[REALM_HEADER] as string
    const items = makeSelectItems(state, showAsWideView)
    return {
        items,
        activeDepartmentIndex,
        isInPrimaryNav,
        textAlignment,
        chevronIconAltText,
        realm,
        variant,
        siteUrl,
        iconsVersionPath,
        templating: state.template,
    }
}

export default connect(mapStateToProps)
